import {useSubscription} from '../../../providers/subscription/useSubscription.ts'
import {ErrorBanner} from '../ErrorBanner.tsx'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../../routes.ts'
import {useProjects} from '../../../providers/projects/useProjects.ts'

export const NoProjectErrorBanner = () => {
  const {activeSubscriptionTier, loading: loadingSubscriptions} = useSubscription()
  const {projects, loading: loadingProjects} = useProjects()
  const navigate = useNavigate()

  if (loadingSubscriptions || loadingProjects) return null

  if (activeSubscriptionTier.tier === 'none') return null

  if (projects.length > 0) return null

  return (
    <ErrorBanner
      color={'orange'}
      buttons={[
        {
          title: 'Manage projects',
          onClick: () => navigate(routes.projects.buildRoute()),
        },
      ]}
    >
      You have no projects.
    </ErrorBanner>
  )
}
